import axios from 'axios';

const path = '/item-creation-wizard';

export const getAvailableItemTypes = async () => {
    const response = await axios.get(`${path}/itemTypes`);

    return response.data;
};

export const getWeatherStations = async () => {
    const response = await axios.get(`${path}/weatherStations`);
    return response.data;
};

export const submitWeatherZone = async (payload) => {
    const response = await axios.post(`${path}/weatherZones`, payload);
    return response.data;
};
